<template>
  <v-container>
    <v-layout row wrap justify-center>
      <v-flex sm8 xs12>
        <v-subheader class="title">Convert Twitch Markers to Resolve EDL Import Format</v-subheader>
        <v-card-text>Multiple files supported, each will get a different color</v-card-text>
        <v-file-input multiple v-model="files" label="Select Twitch Marker CSV Files" @change="loadTextFromFile"></v-file-input>
        <v-btn class="ma-1" @click="copyToClipboard">Copy to Clipboard</v-btn>
        <v-btn class="ma-1" @click="saveToFile">Export to File</v-btn>
        <v-card hover class="mt-7" >
          <v-card-text class="title">
            Importing to Da Vinci Resolve
          </v-card-text>
          <v-card-text class="subheading">
            Right Click on the Timeline Clip
          </v-card-text>
          <v-img src="timelines.png" />
        </v-card>
        
<!--         <v-card hover>
          <v-card-text class="subheading">
            {{this.resolveMarkers}}
          </v-card-text>
        </v-card>

        <v-card hover>
          <v-card-text class="subheading">
            {{this.markers}}
          </v-card-text>
        </v-card> -->

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TwitchWrapper from '@/TwitchWrapper'

export default {
  name: 'Channel',
  data () {
    return {
      files: [],
      response: '',
      markers: [],
      isLoaded: false,
      twitch: new TwitchWrapper(this.$root.$data.clientId),
    }
  },
  created () {
    this.fetchData()
  },
  watch: {
    '$route': 'fetchData'
  },
  computed: {
    resolveMarkers () {
      return this.parseMarkers(this.markers)
    },
  },
  methods: {
    fetchData () {
      return
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.resolveMarkers)
    },
    saveToFile() {
      const data = this.resolveMarkers
      const blob = new Blob([data], {type: 'text/plain'})
      const e = document.createEvent('MouseEvents'),
      a = document.createElement('a');
      a.download = "Markers.edl";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ['text/json', a.download, a.href].join(':');
      e.initEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      a.dispatchEvent(e);
    },
    loadTextFromFile() {
      if(this.files === null){return}
      if(typeof(this.files) == 'array' && this.files.length < 1){ return }

      this.files.forEach(e => {
        let reader = new FileReader()
        reader.onload = e => {
          this.markers.push(e.target.result.trim().split('\n'))
        }
        reader.readAsText(e)
      })
    },
    parseMarkers(markers) {
      let header = 'TITLE: Resolve_Comment_Import\nFCM: NON-DROP FRAME\n'
      let output = header
      let colors = ['Blue','Yellow','Red','Green']

      var c = 0
      for (var f = 0; f < markers.length; f++) {
        for (var i = 0; i < markers[f].length; i++) {
          c++
          let m = markers[f][i].trim().split(",")
          let counter = (c).toString().padStart(3, '0')
          let tc = this.parseTimecode(m[0])
          let comment = m[2] + m[3]

          output += `\n${counter}  001      V     C        ${tc} ${tc} ${tc} ${tc}  \n`
          output += ` |C:ResolveColor${colors[f]} |M:${comment} |D:1\n`
        }
      }
      return output
    },
    parseTimecode(str){
      let tcArr = str.split(":")

      do {
        tcArr.push('00')
      } while (tcArr.length < 4);

      for (var i = 0; i < tcArr.length-1; i++) {
        tcArr[i] = tcArr[i].padStart(2, '0')
      }

      return tcArr.join(':')
    },
  }
}
</script>